import { cn } from '@crm/ui';

/**
 * Colunas por tamanho de tela, no espirito das doze colunas do Bootstrap: a
 * tela e que decide quantos cartoes cabem lado a lado. Escolha um numero que
 * divida a quantidade de cartoes - fileira com buraco parece carregamento que
 * falhou.
 */
export type GridColunas = 1 | 2 | 3 | 4 | 5 | 6 | 7;

export interface CardGridProps {
  /** Celular. Sem valor, dois - e o que cabe em 360px. */
  base?: GridColunas;
  /** Tablet em diante. */
  sm?: GridColunas;
  /** Monitor. */
  lg?: GridColunas;
  /** Monitor largo. */
  xl?: GridColunas;
  /** Tela muito larga (2xl). */
  xxl?: GridColunas;
  className?: string;
  children: React.ReactNode;
}

// Tailwind so gera a classe que existe escrita no codigo: os mapas abaixo sao
// o que faz `grid-cols-5` chegar ao CSS. Nao troque por template string.
const BASE: Record<GridColunas, string> = {
  1: 'grid-cols-1',
  2: 'grid-cols-2',
  3: 'grid-cols-3',
  4: 'grid-cols-4',
  5: 'grid-cols-5',
  6: 'grid-cols-6',
  7: 'grid-cols-7',
};

const SM: Record<GridColunas, string> = {
  1: 'sm:grid-cols-1',
  2: 'sm:grid-cols-2',
  3: 'sm:grid-cols-3',
  4: 'sm:grid-cols-4',
  5: 'sm:grid-cols-5',
  6: 'sm:grid-cols-6',
  7: 'sm:grid-cols-7',
};

const LG: Record<GridColunas, string> = {
  1: 'lg:grid-cols-1',
  2: 'lg:grid-cols-2',
  3: 'lg:grid-cols-3',
  4: 'lg:grid-cols-4',
  5: 'lg:grid-cols-5',
  6: 'lg:grid-cols-6',
  7: 'lg:grid-cols-7',
};

const XL: Record<GridColunas, string> = {
  1: 'xl:grid-cols-1',
  2: 'xl:grid-cols-2',
  3: 'xl:grid-cols-3',
  4: 'xl:grid-cols-4',
  5: 'xl:grid-cols-5',
  6: 'xl:grid-cols-6',
  7: 'xl:grid-cols-7',
};

const XXL: Record<GridColunas, string> = {
  1: '2xl:grid-cols-1',
  2: '2xl:grid-cols-2',
  3: '2xl:grid-cols-3',
  4: '2xl:grid-cols-4',
  5: '2xl:grid-cols-5',
  6: '2xl:grid-cols-6',
  7: '2xl:grid-cols-7',
};

/**
 * Espaco entre cartoes - a mesma medida em toda grade do sistema. Mudar esta
 * linha muda o respiro de todas as telas de cartao.
 */
export const GRID_GAP = 'gap-3 sm:gap-4';

/**
 * Grade de cartoes do sistema: widget do painel, contador do dia, fila de
 * atendimento, listagem em cartao. Todas passam por aqui, entao o espacamento
 * e a quebra por tela mudam em um lugar so.
 */
export function CardGrid({ base = 2, sm, lg, xl, xxl, className, children }: CardGridProps) {
  return (
    <div
      className={cn(
        'grid',
        GRID_GAP,
        BASE[base],
        sm && SM[sm],
        lg && LG[lg],
        xl && XL[xl],
        xxl && XXL[xxl],
        className,
      )}
    >
      {children}
    </div>
  );
}
